{
  "settings": "Innstillinger",
  "yourDigitalAssistant": "Din digitale assistent",
  "getStarted": "Kom i gang",
  "login": "Logg inn",
  "loggingIn": "Logge inn ...",
  "darkMode": "Mørk modus",
  "clearHistory": "Slett logg",
  "historyCleared": "Historien ryddet",
  "endreLanguage": "Språk",
  "termsAndConditions": "Vilkår og betingelser",
  "messagePlaceholder": "Skriv inn meldingen din her ...",
  "messagePlaceholderDisabled": "Skriving deaktivert ...",
  "feedbackTitle": "Ranger opplevelsen din",
  "feedbackPlaceholder": "Fortell oss om det (valgfritt)",
  "feedbackSend": "Sende",
  "feedbackClose": "Lukk",
  "sessionExpired": "Økten din har gått ut på grunn av inaktivitet.",
  "startNewSession": "Start en ny økt",
  "apiError": "Oops! Noe gikk galt. Vi jobber med å fikse dette så snart vi kan.",
  "apiErrorOffline": "Du er ikke koblet til internett.",
  "tryAgain": "Prøv igjen",
  "startOver": "Start på nytt",
  "chatEnded": "Chat er avsluttet.",
  "chatEndedThankYou": "Takk for at du chatter med oss!",
  "closeChat": "Lukk",
  "startNewChat": "Chat igjen",
  "humanTakeoverStarted": "Du blir nå overført til kundeservice ...",
  "humanTakeoverQueued": "Venter på å bli koblet til en agent",
  "humanTakeoverAnAgent": "En agent",
  "humanTakeoverAgentEntered": "gikk inn i samtalen",
  "humanTakeoverAgentLogout": "forlot samtalen",
  "humanTakeoverTransfer": "Du blir overført til en ny agent",
  "humanTakeoverEnded": "Du chatter nå med din digitale assistent",
  "version": "Versjon",
  "formIntroText": "Vennligst fyll ut følgende skjema for å begynne å chatte med oss.",
  "formFirstName": "Fornavn",
  "formLastName": "Etternavn",
  "formName": "Navn",
  "formEmail": "E-post",
  "formWrongEmail": "Oppgi en gyldig e-postadresse.",
  "formPhone": "Telefon",
  "formShipmentId": "Forsendelses-ID",
  "formQuestion": "Ditt spørsmål",
  "formAccountNumber": "Kontonummer (for bedriftskunder)",
  "formAddress": "Adresse",
  "formPostcode": "Postnummer",
  "formCity": "By",
  "formCountry": "Land",
  "formSubmitButton": "Start chat",
  "formEmptyFieldError": "Ikke lov å være tom.",
  "formPhoneNumberValidationError": "Ikke et gyldig telefonnummer.",
  "formInputIsBiggerThan50": "Må maksimalt være 50 tegn.",
  "formInputIsBiggerThan100": "Må maksimalt være 100 tegn.",
  "formInputIsBiggerThan2000": "Må maksimalt være 2000 tegn.",
  "widgetEventOnline": "DA-melding: Bruker er tilbake online.",
  "widgetEventHidden": "DA-melding: Widget er skjult.",
  "widgetEventVisible": "DA-melding: Widget er synlig.",
  "widgetEventVisibleMinimized": "DA-melding: Widget er synlig, men minimert.",
  "widgetEventMinimized": "DA-melding: Widget er minimert.",
  "widgetEventMaximized": "DA-melding: Widget er maksimert.",
  "widgetEventSessionExpired": "DA-melding: Widget-økt utløpt.",
  "widgetEventHangupHuman": "DA -melding: Brukeravslutning Menneskelig overtakelsesøkt.",
  "widgetEventUserTyping": "DA-melding: brukeren skriver.",
  "fileTooLarge": "Du prøver å legge ved for store filer.",
  "tooManyDiles": "Du prøver å legge ved for mange filer.",
  "fileInvalidType": "Du prøver å legge ved ugyldige filtyper.",
  "attachmentsDropHere": "Slipp her for å laste opp eller",
  "attachmentsBrowse": "Bla gjennom filer",
  "attachmentsExtenstionQuantity": "pdf eller bilder (opptil 10 filer)",
  "attachmentsSize": "opptil 30 MB",
  "attachmentsFailedUploading": "Opplasting mislyktes",
  "attachmentsUploading": "Laster opp ...",
  "minimizeExpandText": "Live chat med oss nå!",
  "popupWidgetNotificationMessage": "Du har mottatt en ny melding!",
  "tabWidgetNotificationMessage": "Ny melding!",
  "datepickerSendButton": "Sende"
}
